<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">认证中心</h1>
                    <p class="text-white pb-3 px-3">管理您的认证信息，以便我们更好地为您服务</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <b-tabs
                                active-nav-item-class="text-info"
                                v-model="tabIndex"
                            >
                                <b-tab v-for="tab in tabTitle" :key="tab.key" @click="tabKey = tab.key" class="py-3">
                                    <template v-slot:title>
                                        <div v-if="tabKey == tab.key">
                                            <i class="fas fa-check-circle fa-sm text-success"></i> {{ tab.name }}
                                        </div>
                                        <div v-else><i class="far fa-check-circle fa-sm text-muted"></i> {{ tab.name }}
                                        </div>
                                    </template>
                                    <component :is="tab.key" v-if="tabKey == tab.key"></component>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import verified from "@/views/newPages/Certification/verified.vue";
import CODCertification from "@/views/newPages/Certification/CODCertification.vue";
export default {
    components: {
        verified,
        CODCertification
    },
    name: "",
    data() {
        return {
            busy: false,
            tabIndex: 0,
            tabKey: 'verified',
            tabTitle: [
                {key: 'verified', name: '实名认证'},
                {key: 'CODCertification', name: 'COD认证'},
            ]
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>